<div class="cp-widget np">
  <span class="cp-title-widget-white cp-font-bold" style="text-align: center; margin-top: 1%">{{ literalsCp?.strStatus | uppercase }}</span>

  <div class="po-row np" style="margin-top: 15%;">
    <span class="cp-title-widget-white cp-font-bold"
      style="text-align: center; font-size: 60px;">{{ getFormattedNumberPercentage(taskstatus.percentageState) }}%</span>
  </div>
  <div class="po-row np" style="margin-top: 8px;">
    <span class="cp-title-widget-white cp-font-bold" style="text-align: center; font-size: 14px;">{{ literalsCp?.strTarefaFinalizada }}</span>
  </div>
  <div class="po-row np cp-div" style="height: 270px">
    <cp-barschart class="po-xl-12 po-lg-12 po-md-12 po-sm-12" [params]="paramChart"></cp-barschart>
  </div>
</div>

<po-loading-overlay [hidden]="isHideLoading">
</po-loading-overlay>
